import Typography from "./Typography"
export default Typography
export type {
  ITypography,
  ITypographyElement,
  ITypographyStyleType,
  ILoaderProps
} from "./types"
